<template>
  <div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="
        'Sole Proprietorship Financial Report - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
    >
      <section slot="pdf-content">
        <div class="pdf_docs report-pdf-file" ref="document" v-if="report">
          <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="banner reprt-bnr page">
              <div class="section_body">
                <img src="/img/pdf_logo.png" alt="" class="company_logo" />
                <h1>Sole Proprietorship Financial Report</h1>
                <h6>
                  [{{ parseInt(headerData.bznaics) }}] {{ headerData.industry }}
                </h6>
                <ul>
                  <li>
                    Market Area: <span>{{ headerData.area }}</span>
                  </li>
                  <li>
                    Sales Class: <span>{{ headerData.sales_class }}</span>
                  </li>
                  <li v-if="companyName">
                    Company Name:
                    <h6>
                      <span>{{ companyName }}</span>
                    </h6>
                  </li>
                  <li v-if="releaseDisplay">
                    Release Date: <span>{{ releaseDisplay }}</span>
                  </li>
                </ul>
                <div class="bottom_area">
                  <div class="left">
                    <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt="">
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                  </div>
                  <div v-if="this.headerData.developer_name" class="right">
                    <h5>Developed By</h5>
                    <h3>{{ this.headerData.developer_name }}</h3>
                  </div>
                </div>
              </div>
              <div class="banner_footer">
                <!-- <h6>American Author</h6>-->
                <span class="author">
                  <!--Joyce Meyer-->
                </span>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
            </div>
          </section>
          <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="company_info page">
              <div class="section_body">
                <ul>
                  <li>
                    <h5>About the Data</h5>
                    <p>Value of Bizminer Reports</p>
                  </li>
                  <li>
                    <h5>Summary Scores</h5>
                    <p>
                      Summary Scores All Years (Scale 1-5) <br />Worth Your
                      Focus <br />Ratio Categories <br />Cash-Flow <br />Profit
                      <br />Efficiency <br />Debt
                    </p>
                  </li>
                  <li>
                    <h5>Financials</h5>
                    <p>
                      Income Statement <br />Balance Sheet <br />Sources &amp;
                      Uses of Funds
                    </p>
                  </li>
                  <li>
                    <h5>Ratios</h5>
                    <p>
                      Cash Flow Solvency <br />Profitability <br />Efficiency
                      <br />Cash Debt Risk
                    </p>
                  </li>
                  <li>
                    <h5>Valuation Multiples</h5>
                    <p>
                      Sales Group: &#60; $2.5m <br />Sales Group: $2.5m - $24.9m
                      <br />Sales Group: &#62; $25m <br />Sales Group: All
                    </p>
                  </li>
                </ul>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="about_info page">
              <div class="section_body">
                <div class="section_title">
                  <h2>About the Data</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>
                <div class="data_box_about">
                  <p>
                    Bizminer data is widely accepted for industry analytical
                    work, benchmarking, valuations, forensics and litigation.
                    Bizminer content is accepted in US Tax Court (Bauer vs. IRS:
                    T.C. Memo. 2012-156) and is utilized by state, provincial
                    and national taxing agencies in the US and Canada.
                  </p>
                  <p>
                    Raw data analyzed for Bizminer reports is sourced from an
                    array of the nation's government and private statistical
                    sources. None of these raw data sources creates the final
                    measures reflected in Bizminer industry profiles. In total,
                    Bizminer accesses over a billion sourced data points from 15
                    million business operations for each of its twice annual
                    updates covering a 3-5 year time series. Historical data and
                    Bizminer algorithms are used to inform and test projections
                    for non-reporting firms. Data elements are sourced
                    specifically from:
                  </p>
                </div>
                <div class="list_box">
                  <ul>
                    <li>IRS SOI Corporation Tax Book</li>
                    <li>IRS Statistics of Income</li>
                    <li>US Economic Census</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census County Business Patterns</li>
                    <li>
                      Bureau of Labor Statistics Monthly Employment Reports
                    </li>
                    <li>
                      Bureau of Labor Statistics Monthly Unemployment Reports
                    </li>
                    <li>Bureau of Labor Statistics Annual Wage Survey</li>
                    <li>Bureau of Labor Statistics Industry</li>
                    <li>Reports</li>
                    <li>Bureau of Labor Statistics Price Indices</li>
                    <li>National Agricultural Statistical Service</li>
                    <li>US Census Quarterly Financial Reports</li>
                    <li>US Census Retail Trade Report</li>
                    <li>Data Axle</li>
                    <li>Business Valuation Resources (BVR)</li>
                    <li>Credit Reporting Agencies</li>
                    <li>Business Directories</li>
                    <li>American Community Survey</li>
                  </ul>
                </div>
                <div class="about_bottom">
                  <p>
                    While 100% firm coverage is desirable for analysis purposes,
                    the greatest value of Bizminer reports rests in discerning
                    patterns of activity, which are reflected in the large
                    samples used to develop our reports. The overall current
                    coverage of the databases surpasses 13 million active
                    business operations at any point in time.
                  </p>
                  <p>
                    As is the case with any databases this large, some errors
                    are inevitable. Some firms are missed and specific
                    information on others is lacking from the database. Not all
                    information received is uniform or complete, resulting in
                    the need to develop projection algorithms for specific
                    industry segments and metrics in some report series. No
                    representation is made as to the accuracy of the databases
                    utilized or the results of subsequent analyses.
                  </p>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score summary-score page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Summary Score</h2>
                  <span class="date">{{
                    moment(new Date()).format("MMM Do YYYY")
                  }}</span>
                </div>
                <div class="md-layout pt-4">
                  <div
                    v-if="summaryScoreChartData"
                    class="md-layout-item md-size-100"
                  >
                    <DonutChart :chartdata="summaryScoreChartData" />
                    <div class="score-donut-overlay">
                      <div class="heading">SWOT<br />Overall Score</div>
                      <div class="score">{{ overallScore }}/5</div>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-100 p-0">
                    <h5>Summary Scores All Years (Scale 1-5)</h5>
                    <p class="small">
                      Based on your inputs, the Industry Financial Report
                      calculates the percentage difference (variance) between
                      client ratios and the industry average for the selected
                      industry peer group. Your firm performance on each ratio
                      is scored on a 1-5 scale (5 being best) for each year
                      displayed in the report. The scoring approach depends on
                      the specific scored ratio. You can find a detailed
                      explanation for each at the end of this report.
                    </p>
                    <p class="small">
                      The value of peer comparisons with your business depends
                      on the accuracy and completeness of the firm financial
                      information that is being entered. The more detail that
                      you provide, the more comprehensive and meaningful the
                      benchmark.
                    </p>
                    <p class="small">
                      For each ratio, the score for those years selected from
                      the most recent three calendar years is averaged and
                      integrated into a Ratio Category Score. The Score for each
                      of the four categories (Cash Flow/Solvency; Profitability;
                      Efficiency; Debt-Risk) are then averaged to produce an
                      Overall Score.
                    </p>

                    <md-table
                      v-if="
                        this.display_summary_scores && this.summaryScoresAll
                      "
                      v-model="summaryScoresAll"
                      table-header-color="blue"
                      class="mb-2 mt-4"
                    >
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Title">
                          {{ item.title }}
                        </md-table-cell>
                        <md-table-cell md-label="Score">
                          {{ item.rating }}
                        </md-table-cell>
                        <md-table-cell
                          md-label="Rating"
                          class="td-actions text-right"
                        >
                          <div class="md-button-content">
                            <md-icon
                              v-for="(v, i) in getStars(item.rating)"
                              :key="i + item.title"
                              >{{ v }}</md-icon
                            >
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score page">
              <div class="section_body">
                <div class="negetive_margin">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 mb-2">
                      <div class="tble-box">
                        <div class="tbl-title">
                          <h4>Ratio Categories</h4>
                        </div>
                        <p class="pl-2 pr-2">
                          The Bizminer Industry Financial Report is based on
                          selected financial ratios that are typically
                          considered to be Key Performance Indicators (KPIs)
                          which includes:
                        </p>
                        <div class="inner-tbl">
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Cash Flow/Solvency:</h4>
                            <p>
                              Cash Flow ratios indicate a company's ability to
                              meet various levels of demand on cash and easily
                              obtainable cash resources against current and
                              anticipated near-term payments due.
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Profitability:</h4>
                            <p>
                              Profitability ratios compare levels of return
                              against various expense and balance sheet
                              components to measure your performance against
                              reasonable industry peer group standards,
                              indicating bottom line performance,
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Efficiency:</h4>
                            <p>
                              Efficiency ratios measure your success in
                              marshalling resources at hand to effectively
                              manage various components of your business
                              operations. These indicators often point most
                              specifically toward actions that could enhance
                              your bottom line.
                            </p>
                          </div>
                          <div class="list-tick">
                            <img src="/img/tick-blue.png" alt="" />
                            <h4>Debt-Risk:</h4>
                            <p>
                              Debt-Risk ratios assess the appropriateness of a
                              firm’s level of debt against the ability to pay,
                              as well as the risk of insolvency.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="overall_score summary-score page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Worth Your Focus</h2>
                </div>
                <div class="md-layout pt-4">
                  <div class="md-layout-item md-size-100 p-0">
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <h5>Worth Your Focus:</h5>
                        <p class="small">
                          Ratio Category scores are simply a reflection of the
                          more focused individual ratios that they include. Any
                          ratios that score below 3.0 should be examined closely
                          for weaknesses in management or performance that could
                          be improved with reasonable effort and expense. While
                          you should work with a qualified advisor to obtain
                          specific guidance, we’ve flagged these areas for
                          attention:
                        </p>
                      </div>
                    </div>
                    <div v-if="worthYourFocus" class="md-layout score mt-4">
                      <div class="md-layout-item md-size-100">
                        <h5 class="table_header purple-bg">Worth Your Focus</h5>
                      </div>
                    </div>
                    <md-table
                      v-if="worthYourFocus"
                      v-model="worthYourFocus"
                      table-header-color="blue"
                      class="w-100 no_head"
                    >
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label>
                          {{ item.title }}
                        </md-table-cell>
                        <md-table-cell md-label>
                          {{ parseFloat(item.rating).toFixed(2) }}
                        </md-table-cell>
                        <md-table-cell md-label class="td-actions">
                          <div class="md-button-content">
                            <md-icon
                              v-for="(v, i) in getStars(item.rating)"
                              :key="i + item.title"
                              >{{ v }}</md-icon
                            >
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
              <p class="common_footer pt-4">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Industry Financials</h2>
                </div>
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataFirmPercent" class="inner-tbl">
                      <md-table
                        v-model="tableDataFirmPercent"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            :md-label="companyName"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableDataIndustryPercent" class="inner-tbl">
                      <md-table
                        v-model="tableDataIndustryPercent"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            md-label="Industry"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            {{ item.dates[key] }}%
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div>
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataFirmDollar" class="inner-tbl">
                      <md-table
                        v-model="tableDataFirmDollar"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            :md-label="headerData.client_name"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div>
                  <div class="tble-box">
                    <div class="tbl-title ">
                      <h4>Dollars ( All figures in USD )</h4>
                    </div>
                    <div v-if="tableDataIndustryDollar" class="inner-tbl">
                      <md-table
                        v-model="tableDataIndustryDollar"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            md-label="Industry"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            ${{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page22" slot="pdf-content" class="pdf_docs prfl-pdf">
            <SPIFRPDFRatios :headerInfo="headerData" />
          </section>

          <section ref="page23" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="value_multiples page">
              <div class="section_body">
                <div class="section_title mb-2">
                  <h2>Valuation Multiples</h2>
                </div>
                <div class="negetive_margin">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <h3 class="sub_header mt-4">About Valuation Multiples</h3>

                      <h4>
                        <b>Business Value Insight Terms</b>: The Bizminer
                        Valuations Value basis is derived from projected company
                        sales; peer group average earnings %; and industry
                        valuation multiples. Median ranges reflect a range of
                        market conditions and business performance at this
                        revenue scale.<br /><br />
                        You should not use Bizminer Valuations in place of a
                        professional valuation or as the basis of any specific
                        business-related or other financial transaction; nor to
                        secure a business or personal loan.<br /><br />
                        <b>Owner Earnings (Cash Flow) Approach:</b>
                        Revenue/Owner Earnings market valuation approach<br /><br />
                        <b>Sales Approach:</b> Revenue/Annual Sales market value
                        approach<br /><br />
                        <b>Note:</b> Median is the point at which 50% of a
                        sample is above and 50% of the same below the value.
                        Quartile 1 lies at the mid-point between the median and
                        the lowest value; Quartile 3 between the median and the
                        highest value.
                      </h4>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50">
                      <h5>Sales Group: &#60; $2.5m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesA[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesA[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div v-if="tableInfo" class="md-layout-item md-size-50">
                      <h5>Sales Group: $2.5m - $24.9m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesB[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesB[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div
                      v-if="tableInfo"
                      class="md-layout-item md-size-50 mt-2"
                    >
                      <h5>Sales Group: &#62; $25m</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesC[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesC[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div
                      v-if="tableInfo"
                      class="md-layout-item md-size-50 mt-2"
                    >
                      <h5>Sales Group: All</h5>
                      <md-table v-model="tableInfo" table-header-color="blue">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell md-label>
                            <div class="md-table-side-label">
                              {{ item.name }}
                            </div>
                          </md-table-cell>
                          <md-table-cell md-label="Sales Multiples">
                            {{ multiplesAll[`Sales${item.id}`] }}
                          </md-table-cell>
                          <md-table-cell md-label="Earnings Multiples">
                            {{ multiplesAll[`Earnings${item.id}`] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page24" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Cash Tables</h2>
                </div>
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Dollars</h4>
                    </div>
                    <div v-if="tableAnnualCashRatiosDollar" class="inner-tbl">
                      <md-table
                        v-model="tableAnnualCashRatiosDollar"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            :md-label="companyName"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            {{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>

          <section ref="page25" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="industry_financials_sec page">
              <div class="section_body">
                <div class="section_title">
                  <h2>Cash Tables</h2>
                </div>
                <div>
                  <div class="tble-box">
                    <div class="tbl-title">
                      <h4>Percentages</h4>
                    </div>
                    <div v-if="tableAnnualCashRatiosPercent" class="inner-tbl">
                      <md-table
                        v-model="tableAnnualCashRatiosPercent"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                      >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            :md-label="companyName"
                            :class="
                              item.name === 'Cost of Sales - Labor Portion'
                                ? 'md-table-side-label pl-2'
                                : 'md-table-side-label'
                            "
                          >
                            {{ item.name }}
                          </md-table-cell>

                          <md-table-cell
                            v-for="key in Object.keys(item.dates)"
                            :key="key"
                            :md-label="key"
                          >
                            {{ item.dates[key] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapState } from "vuex";
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import SPIFRPDFRatios from "./SPIFRPDFRatios.vue";
import DonutChart from "@/components/DonutChart.vue";
import moment from "moment";

export default {
  components: {
    VueHtml2pdf,
    SPIFRPDFRatios,
    DonutChart,
  },
  props: ["headerData", "user"],
  mixins: [ratingMixin, formatData],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "auto",
        },
      },
      tableData: [],
      filtered_years: ['"Firms Analyzed"'],
      filtered_firms: [""],
      convertData: [],
      tableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      moment: moment,

      tableDataIndustryDollar: [],
      tableDataIndustryDollarBalanceSheet: [],
      tableDataIndustryPercent: [],
      tableDataIndustryPercentBalanceSheet: [],
      tableDataFirmDollar: [],
      tableDataFirmDollarBalanceSheet: [],
      tableDataFirmPercent: [],
      tableDataFirmPercentBalanceSheet: [],
      tableDataVarianceDollar: [],
      tableDataVarianceDollarBalanceSheet: [],
      tableAnnualCashRatiosDollar: [],
      tableAnnualCashRatiosPercent: [],
      newChartFirmPercentOptions: [],
      newChartFirmPercentOptionsBalanceSheet: [],
      newChartIndustryPercentOptions: [],
      newChartIndustryDollarOptions: [],
      newChartFirmDollarOptions: [],
      newChartVarianceDollarOptions: [],
      summaryChartData: [],
      scoreChartOptions: {
        donut: true,
        showLabel: false,
        legendNames: [],
        height: "150px",
        width: "150px",
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6,
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6,
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      charts: [],
      chartsBalanceSheet: [],
      chartsChunks: [],
      chartsChunksBalanceSheet: [],
      options: {
        donut: true,
        showLabel: false,
        legendNames: [],
        height: "150px",
      },
      display_by_dollars: true,
      display_by_percentages: true,
      display_by_variance: true,
      display_summary_scores: true,
      multipleBarsChart: {
        data: {
          labels: [ // TODO: make this automatic.
            "Jan 2019",
            "July 2019",
            "Jan 2020",
            "July 2020",
            "Jan 2021",
          ],
          series: [
            [0.8, 1.4, 1.8, 2.5, 2.2],
            [0.9, 1.3, 2.0, 2.8, 2.6],
            [1.1, 1.6, 2.3, 2.1, 3.0],
            [1.4, 1.2, 2.5, 2.2, 2.8],
            [1.2, 1.2, 2.8, 1.8, 2.4],
            [1.2, 1.7, 1.8, 1.9, 2.5],
          ],
        },
        options: {
          seriesBarDistance: 19,
          high: 4,
          axisX: {
            showGrid: false,
          },
          axisY: {
            offset: 80,
            labelInterpolationFnc: function(value) {
              return "$" + value + "M";
            },
          },
          height: "150px",
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      industrySummaryChart: null,
      summaryScoreChartData: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    headerInfo() {},
    report(newVal, oldVal) {
      this.init();
    },
    overallScore(newVal, oldVal) {
      this.summaryScoreChartData = [newVal, 5];
    },
  },
  computed: {
    ...mapState({
      worthYourFocus: (state) => state.user.report.data["worthYourFocus"],
      report: (state) => state.user.report.data,
      narrativeText: (state) => state.user?.report?.data.narrativeText,
      overallScore: (state) =>
        state.user?.report?.data?.summaryScores?.overall?.rating,
      naicsDrilldown: (state) => state.user.report.data["naicsDrilldown"],
      showYears: (state) => state.user?.report?.data?.showYears,
      years: (state) => state.user.report.data.years,
      PLtable: (state) => state.user.report.data.tables["PL"],
      chartData: (state) => state.user.report.data.chartData["profitLoss"],
      chartDataBalanceSheet: (state) =>
        state.user.report.data.chartData["balanceSheet"],
      annualCashRatiosDollar: (state) =>
        state.user.report.data.tables.annual_cash_ratios_dollar,
      annualCashRatiosPercent: (state) =>
        state.user.report.data.tables.annual_cash_ratios_percent,
      table: (state) => state.user.report.data.tables["PL"],
      tableBalanceSheet: (state) => state.user.report.data.tables["BS"],
      summaryScores: (state) => state.user.report.data["summaryScores"],
      companyName: (state) => state.user?.companyName,
      developer: (state) =>
        state.user?.report?.data.developerClient?.developer_name,
      releaseDisplay: (state) =>
        state?.user?.report?.data.release_display
          ? state?.user?.report?.data.release_display.replace("-", " ")
          : "",

      multiplesA: (state) => {
        return state.user.report.data["multiples_A"]
          ? state.user.report.data["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.report.data["multiples_B"]
          ? state.user.report.data["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.report.data["multiples_C"]
          ? state.user.report.data["multiples_C"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report.data["multiples_all"]
          ? state.user.report.data["multiples_all"]
          : [];
      },
    }),
    filteredProfile() {
      return _.omit(this.report.data, "array_customer");
    },
    summaryScoresAll() {
      if (this.summaryScores) {
        let k;
        if ("ratios" in this.summaryScores && this.summaryScores.ratios) {
          k = this.summaryScores.ratios;
        } else {
          k = "";
        }

        return [this.summaryScores.overall, ...Object.values(k)];
      } else {
        return "";
      }
    },
    summaryScoresRatios() {
      if (this.summaryScores) {
        let k;
        if ("ratios" in this.summaryScores && this.summaryScores.ratios) {
          k = this.summaryScores.ratios;
        } else {
          k = "";
        }

        return [this.summaryScores.ratios, ...Object.values(k)];
      } else {
        return "";
      }
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.pdfLoading = true;

      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page22 = this.$refs.page22;
      let page23 = this.$refs.page23;
      let page24 = this.$refs.page24;
      let page25 = this.$refs.page25;

      let pages = [
        page1,
        page2,
        page3,
        page4,
        page5,
        page6,
        page7,
        page8,
        page9,
        page10,
        page22,
        page23,
        page24,
        page25,
      ];

      options.pagebreak = {
        avoid: ".industry-location",
        mode: "css",
        after: ".br-after",
      };
      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.pdfLoading = false;
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    init() {
      if (!this.showYears) {
        return;
      }

      let filtered_years = [];
      let me = this;
      Object.keys(this.showYears).forEach((k, i) => {
        if (this.showYears[k]) {
          filtered_years.push(this.years[i]);
        }
      });
      if (!filtered_years.length) {
        filtered_years = this.years;
      }
      if (!filtered_years || !filtered_years.length) {
        filtered_years = this.years;
      }
      filtered_years.forEach((s, i) => {
        this.filtered_years.push(Number(s));
      });
      this.tableData = Object.values(this.filteredProfile).filter((item) => {
        if (filtered_years.includes(item.year)) {
          return {
            ...item,
            firms: item.firms,
          };
        }
      });
      this.tableData.forEach((element) => {
        if (filtered_years.includes(element.year)) {
          this.filtered_firms.push(Number(element.firms));
        }
      });

      this.tableData = this.tableData.map((item) => {
        return {
          ...item,
          firms: me.numberWithCommas(item.firms),
        };
      });

      this.tableData = _.orderBy(this.tableData, ["year"], ["asc"]);
      let seriesFilter = [];
      Object.values(this.filteredProfile).forEach((item, index) => {
        if (filtered_years.includes(item.year)) {
          seriesFilter.push(item.firms);
        }
      });
      if (!seriesFilter || !seriesFilter.length) {
        seriesFilter = Object.values(this.filteredProfile).map(
          (item) => item.firms
        );
      }

      this.industrySummaryChart = {
        labels: filtered_years,
        series: [{ name: "Firms", data: seriesFilter.reverse() }],
      };

      if (
        this.report.displaySettings.includes("pl_balance_percent") &&
        this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_dollars = true;
        this.display_by_percentages = true;
        this.display_by_variance = true;
      }
      if (
        this.report.displaySettings.includes("pl_balance_dollar") &&
        !this.report.displaySettings.includes("pl_balance_percent")
      ) {
        this.display_by_dollars = true;
        this.display_by_variance = true;
      }
      if (
        this.report.displaySettings.includes("pl_balance_percent") &&
        !this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_percentages = true;
        this.display_by_variance = true;
      }
      if (
        !this.report.displaySettings.includes("pl_balance_percent") &&
        !this.report.displaySettings.includes("pl_balance_dollar")
      ) {
        this.display_by_dollars = false;
        this.display_by_percentages = false;
        this.display_by_variance = false;
      }

      if (!this.report.displaySettings.includes("pl_balance_percent"))
        this.display_by_percentages = false;

      if (!this.report.displaySettings.includes("pl_balance_dollar"))
        this.display_by_dollars = false;

      Array.from(this.showYears).forEach((s, i) => {
        if (s) {
          filtered_years.push(this.years[i]);
        }
      });
      if (!filtered_years.length) {
        filtered_years = this.years;
      }

      this.tableDataVarianceDollar = this.formatTable(
        this.table,
        "variance",
        "dollar"
      );
      this.tableDataVarianceDollar = this.tableDataVarianceDollar.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataVarianceDollar.forEach((element) => {
        this.newChartVarianceDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataVarianceDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "variance",
        "dollar"
      );
      this.tableDataVarianceDollarBalanceSheet = this.tableDataVarianceDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataVarianceDollarBalanceSheet.forEach((element) => {
        this.newChartVarianceDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryDollar = this.formatTable(
        this.table,
        "industry",
        "dollar"
      );
      this.tableDataIndustryDollar = this.tableDataIndustryDollar.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableAnnualCashRatiosDollar = this.formatTable(
        this.annualCashRatiosDollar,
        "industry",
        "dollar"
      );
      this.tableAnnualCashRatiosDollar = this.tableAnnualCashRatiosDollar.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return filtered_years && !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableAnnualCashRatiosPercent = this.formatTable(
        this.annualCashRatiosPercent,
        "industry",
        "percent"
      );
      this.tableAnnualCashRatiosPercent = this.tableAnnualCashRatiosPercent.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return filtered_years && !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryDollar.forEach((element) => {
        this.newChartIndustryDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "industry",
        "dollar"
      );
      this.tableDataIndustryDollarBalanceSheet = this.tableDataIndustryDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryDollarBalanceSheet.forEach((element) => {
        this.newChartIndustryDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryPercent = this.formatTable(
        this.table,
        "industry",
        "percent"
      );
      this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryPercent.forEach((element) => {
        this.newChartIndustryPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataIndustryPercentBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "industry",
        "percent"
      );
      this.tableDataIndustryPercentBalanceSheet = this.tableDataIndustryPercentBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );

      this.tableDataIndustryPercentBalanceSheet.forEach((element) => {
        this.newChartIndustryPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmDollar = this.formatTable(this.table, "firm", "dollar");
      this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.tableDataFirmDollar.forEach((element) => {
        this.newChartFirmDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmDollarBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "firm",
        "dollar"
      );
      this.tableDataFirmDollarBalanceSheet = this.tableDataFirmDollarBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });
          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );
      this.tableDataFirmDollarBalanceSheet.forEach((element) => {
        this.newChartFirmDollarOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });
      this.tableDataFirmPercent = this.formatTable(
        this.table,
        "firm",
        "percent"
      );
      this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });

        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.tableDataFirmPercentBalanceSheet = this.formatTable(
        this.tableBalanceSheet,
        "firm",
        "percent"
      );
      this.tableDataFirmPercentBalanceSheet = this.tableDataFirmPercentBalanceSheet.map(
        (item) => {
          let changeDates = Object.keys(item.dates);
          changeDates = changeDates.filter((fItem) => {
            return !filtered_years.includes(fItem);
          });

          let newDates = item.dates;
          changeDates.map((el) => {
            delete newDates[el];
          });
          let obj = {
            ...item,
            dates: newDates,
          };

          return obj;
        }
      );
      this.tableDataFirmPercent.forEach((element) => {
        this.newChartFirmPercentOptions[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.tableDataFirmPercentBalanceSheet.forEach((element) => {
        this.newChartFirmPercentOptionsBalanceSheet[element.name] = {
          data: {
            labels: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
            series: [
              [
                ...Object.keys(element.dates).map((i) =>
                  element.dates[i]
                    .toString()
                    .replace(/,/g, "")
                    .replace("%", "")
                ),
              ],
            ],
          },
        };
      });

      this.charts = this.formatPieChart(this.chartData);
      this.charts = this.charts.filter(function(el) {
        return el.type === "dollar";
      });
      this.chartsBalanceSheet = this.formatPieChart(this.chartDataBalanceSheet);
      this.chartsBalanceSheet = this.chartsBalanceSheet.filter(function(el) {
        return el.type === "dollar";
      });
      // this.chartsChunks = this.charts.chunk(4);
      // this.chartsChunksBalanceSheet = this.chartsBalanceSheet.chunk(4);

      this.summaryChartData = {
        labels: [""],
        series: [[1, 1]],
      };
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (typeof x === "string") {
        return x.replace(/,/g, ".");
      } else {
        return x;
      }
    },
  },
};
</script>
